import { takeEvery, select, call, put, delay } from 'redux-saga/effects';
import serviceData from '../../services/ocularis';
import {getEventsInfo} from "../API/actions";



function* addCaseSaga(action) {
    const { name, comment } = action;
    const { token } = yield select(state => state.API);
    try {
        yield call(() => {serviceData.addCase(token, name, comment)});

        yield delay(200);
        yield put(getEventsInfo());
    } catch(e) {
        // console.log(`Couldn't add new case!`);
    }
}

export default function*() {
    yield takeEvery('ALERT_ADD_EVENT_CASE', addCaseSaga)
}